// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"e0","imgTextCardBox":"e0","text-box":"e1","textBox":"e1","remark-val":"e2","remarkVal":"e2"};